"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));

var Image_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Image"));

var Loader_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Loader"));

var Table_1 = require("@sportnet/ui/lib/Table");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var utilities_2 = require("@sportnet/ui/lib/utilities");

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var CoreApi_1 = tslib_1.__importDefault(require("../../../api/CoreApi"));

var setupApis_1 = require("../../../api/setupApis");

setupApis_1.setupCoreApi();
var TopPanel = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var OrganizationName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: bold;\n"], ["\n  font-size: ", ";\n  font-weight: bold;\n"])), polished_1.rem(25));
var PersonDetail = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", " {\n    flex-direction: row;\n  }\n  justify-content: space-between;\n  padding-top: ", ";\n  & > div {\n    width: 100%;\n    text-align: center;\n    ", " {\n      width: 50%;\n      text-align: initial;\n    }\n  }\n  img {\n    width: ", ";\n    height: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", " {\n    flex-direction: row;\n  }\n  justify-content: space-between;\n  padding-top: ", ";\n  & > div {\n    width: 100%;\n    text-align: center;\n    ", " {\n      width: 50%;\n      text-align: initial;\n    }\n  }\n  img {\n    width: ", ";\n    height: 100%;\n  }\n"])), utilities_1.mb('s'), polished_1.rem(20), utilities_1.mb('s'), polished_1.rem(200));
var Wrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  font-family: 'Roboto', sans-serif;\n"], ["\n  font-family: 'Roboto', sans-serif;\n"])));

var C = function (_a) {
  var id = _a.id,
      handleClose = _a.handleClose;

  var _b = React.useState(false),
      isFetching = _b[0],
      setIsFetching = _b[1];

  var _c = React.useState(null),
      organizationProfile = _c[0],
      setOrganizationProfile = _c[1];

  var _d = React.useState([]),
      sportTypes = _d[0],
      setSportTypes = _d[1];

  var _e = React.useState([]),
      profileTypes = _e[0],
      setProfileTypes = _e[1];

  var _f = React.useState([]),
      addressTypes = _f[0],
      setAddressTypes = _f[1];

  var _g = React.useState([]),
      bankAccountTypes = _g[0],
      setBankAccountTypes = _g[1];

  var _h = React.useState([]),
      countries = _h[0],
      setCountries = _h[1];

  var _j = React.useState([]),
      addresses = _j[0],
      setAddresses = _j[1];

  var _k = React.useState([]),
      bankAccounts = _k[0],
      setBankAccounts = _k[1];

  var _l = React.useState(null),
      organization = _l[0],
      setOrganization = _l[1];

  var fetchData = function () {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var ppo, organizationData, bankAccountsItems, addressesItems, sportTypesItems, profileTypesItems, addressTypesItems, bankAccountTypesItems, countryItems, e_1;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setIsFetching(true);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 11, 12, 13]);

            return [4
            /*yield*/
            , CoreApi_1["default"].organizationPPOProfile(id)];

          case 2:
            ppo = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].organizationInvoiceProfile(ppo.organization_id || '')];

          case 3:
            organizationData = _a.sent();
            setOrganization(organizationData);
            return [4
            /*yield*/
            , CoreApi_1["default"].ppoOrganizationBankAccounts(id)];

          case 4:
            bankAccountsItems = _a.sent().items;
            return [4
            /*yield*/
            , CoreApi_1["default"].ppoOrganizationAddresses(id)];

          case 5:
            addressesItems = _a.sent().items;
            return [4
            /*yield*/
            , CoreApi_1["default"].getCodelist('sport')];

          case 6:
            sportTypesItems = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].getCodelist('organization-profile-type')];

          case 7:
            profileTypesItems = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].getCodelist('address-type')];

          case 8:
            addressTypesItems = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].getCodelist('bank-account-type')];

          case 9:
            bankAccountTypesItems = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].getCodelist('country')];

          case 10:
            countryItems = _a.sent();
            setSportTypes(sportTypesItems.codelist || []);
            setProfileTypes(profileTypesItems.codelist || []);
            setAddressTypes(addressTypesItems.codelist || []);
            setBankAccountTypes(bankAccountTypesItems.codelist || []);
            setCountries(countryItems.codelist || []);
            setOrganizationProfile(ppo);
            setAddresses(addressesItems || []);
            setBankAccounts(bankAccountsItems || []);
            return [3
            /*break*/
            , 13];

          case 11:
            e_1 = _a.sent();
            alert(utilities_2.__('Nepodarilo sa získať podrobné údaje'));
            return [3
            /*break*/
            , 13];

          case 12:
            setIsFetching(false);
            return [7
            /*endfinally*/
            ];

          case 13:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var getPhoto = function () {
    if (organizationProfile && organizationProfile.logo_public_url) {
      return React.createElement(Image_1["default"], {
        src: String(organizationProfile.logo_public_url)
      });
    }

    return null;
  };

  var getSportType = function (value) {
    var item = sportTypes.find(function (i) {
      return i.value === value;
    });

    if (item) {
      return React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Šport'))), React.createElement(Table_1.Td, null, item.label));
    }

    return null;
  };

  var getProfileType = function (value) {
    var item = profileTypes.find(function (i) {
      return i.value === value;
    });

    if (item) {
      return React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Typ organizácie'))), React.createElement(Table_1.Td, null, item.label));
    }

    return null;
  };

  var getAddressType = function (value) {
    var item = addressTypes.find(function (i) {
      return i.value === value;
    });

    if (item) {
      return item.label;
    }

    return value;
  };

  var getBankAccountType = function (value) {
    var item = bankAccountTypes.find(function (i) {
      return i.value === value;
    });

    if (item) {
      return item.label;
    }

    return value;
  };

  var getCountry = function (value) {
    var item = countries.find(function (i) {
      return i.value === value;
    });

    if (item) {
      return item.label;
    }

    return value;
  };

  React.useEffect(function () {
    fetchData();
  }, []);

  if (isFetching) {
    return React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, React.createElement(Loader_1["default"], {
      size: "xl"
    }));
  }

  var photo = getPhoto();
  return React.createElement(Wrapper, null, React.createElement(TopPanel, null, React.createElement(OrganizationName, null, organizationProfile && organizationProfile.name), React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: function () {
      return handleClose();
    }
  }, React.createElement(Icon_1["default"], {
    name: "close",
    size: "xl"
  }))), React.createElement(PersonDetail, null, photo && photo, React.createElement("div", tslib_1.__assign({}, !photo && {
    style: {
      width: '100%'
    }
  }), React.createElement(Table_1.Table, null, React.createElement(Table_1.Tbody, null, getSportType(organizationProfile ? organizationProfile.sport || '' : ''), getProfileType((organizationProfile === null || organizationProfile === void 0 ? void 0 : organizationProfile.type) || ''), organization && organization.contact_person && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Kontaktná osoba'))), React.createElement(Table_1.Td, null, organization.contact_person)), organization && organization.www && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Web'))), React.createElement(Table_1.Td, null, React.createElement("a", {
    href: organization.www
  }, organization.www))), organization && organization.email && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Email'))), React.createElement(Table_1.Td, null, React.createElement("a", {
    href: "mailto:" + organization.email
  }, organization.email))), organization && organization.phone && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Telefónne číslo'))), React.createElement(Table_1.Td, null, React.createElement("a", {
    href: "tel:" + organization.phone
  }, organization.phone))), addresses.map(function (a) {
    return React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, getAddressType(a.type || ''))), React.createElement(Table_1.Td, null, a.street, " ", a.number, ", ", a.zip, " ", a.city, ",", ' ', getCountry(a.country || '')));
  }), bankAccounts.map(function (ba) {
    return React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, getBankAccountType(ba.type || ''))), React.createElement(Table_1.Td, null, ba.IBAN));
  }))))));
};

exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;